import React from 'react';

import { Input } from '@interlayer/js/components/common/Fields/Input/Input';

import { clsb } from '@core/js/utils/classNames.util';

import { TInputsRowProps } from './types';

import style from './InputsRow.scss';

export const InputsRow: React.FC<TInputsRowProps> = ({
    options,
    isSeparateRows,
    isShowValidationIcon,
    classNames = {}
}) => {
    const buildCls = clsb([style, classNames]);

    const renderInputs = () => {
        return (
            <>
                {options.map(({ placeholder, type = 'text', name, ...other }, index) => (
                    <Input
                        isShowValidationIcon={isShowValidationIcon}
                        className={buildCls(['input'])}
                        classNames={{ content: style.content }}
                        key={index}
                        placeholder={placeholder}
                        type={type}
                        name={name}
                        {...other}
                    />
                ))}
            </>
        );
    };

    if (isSeparateRows) {
        return renderInputs();
    }

    return (
        <div className={buildCls(['wrap'])}>
            {renderInputs()}
        </div>
    );
};
